<template>
  <div class="home">
    <!--                        首页内容 -->
    <div class="head_img">
      <img src="../assets/img/homeLogo.png" alt="北京翼任科技发展有限公司" />
    </div>
    <div class="company_name animate__bounceInDown animate__animated">
      北京翼任科技发展有限公司
    </div>
    <!-- main -->
    <div class="main animate__backInLeft animate__animated">
      <h2 class="main_title">主要业务</h2>
      <p>MAIN BUSINESS</p>
      <div class="line"></div>
    </div>
    <div class="product_list">
      <div
        v-for="item in productList"
        :key="item.id"
        class="list_item"
        @click="select(item.id)"
      >
        <img :src="item.topImgs" :alt="item.name" />
        <p class="info">{{ item.name }}</p>
        <div class="topBox">
          <img class="topImg" :src="item.imgs" :alt="item.name" />
          <p style="margin-top: 30px">企业智能定制化</p>
        </div>
      </div>
    </div>
    <!-- 合作伙伴 -->
    <div class="main animate__backInLeft animate__animated">
      <h2 class="main_title">合作伙伴</h2>
      <p>PARTNERS</p>
      <div class="line"></div>
    </div>
    <div class="partners_list" :class="isshowAnimation ? 'showView' : ''">
      <div class="list_item">
        <img src="../assets/partners/zhonglian.png" alt="" />
      </div>
      <div class="list_item">
        <img src="../assets/partners/zhonghang.png" alt="" />
      </div>
      <div class="list_item">
        <img src="../assets/partners/shoudu.png" alt="" />
      </div>
      <div class="list_item">
        <img src="../assets/partners/daallo.png" alt="" />
      </div>
      <div class="list_item">
        <img src="../assets/partners/gree.png" alt="" />
      </div>
      <div class="list_item">
        <img src="../assets/partners/beijingsubway.png" alt="" />
      </div>
      <div class="list_item">
        <img src="../assets/partners/air.png" alt="" />
      </div>
      <div class="list_item">
        <img src="../assets/partners/zhongdianzi.png" alt="" />
      </div>
      <div class="list_item">
        <img src="../assets/partners/jinshu.png" alt="" />
      </div>
      <div class="list_item">
        <img src="../assets/partners/x.png" alt="" />
      </div>
      <div class="list_item">
        <img src="../assets/partners/beijingdianzi.png" alt="" />
      </div>
      <div class="list_item">
        <img src="../assets/partners/hangtiansanyuan.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeView",
  props: {},
  data() {
    return {
      isshowAnimation: false,
      productList: [
        {
          name: "提供智能化、信息化、数字化、自动化的工业物联网建设思路",
          imgs: require("@/assets/img/gonye.png"),
          topImgs: require("@/assets/img/top/gonyetop.png"),
          id: 1,
          type: "InDusTry",
        },
        {
          name: "提供一站式智慧城市系统包括智能应急、交通、仓储、安防、运输等",
          imgs: require("@/assets/img/city.png"),
          topImgs: require("@/assets/img/top/citytop.png"),
          id: 2,
          type: "CityView",
        },
        {
          name: "围绕停车的全场景、全流程、全业务的智慧化能力",
          imgs: require("@/assets/img/parking.png"),
          topImgs: require("@/assets/img/top/parktop.png"),
          id: 3,
          type: "ParkView",
        },
      ],
    };
  },
  mounted() {
    // console.log("创建");
    window.addEventListener("scroll", this.scrollHandler, true);
  },
  methods: {
    scrollHandler() {
      const offset = this.$el.getBoundingClientRect();
      const offsetTop = offset.top;
      const offsetBottom = offset.bottom;
      if (offsetTop <= window.innerHeight && offsetBottom >= 0) {
        this.isshowAnimation = true;
      } else {
        this.isshowAnimation = false;
      }
    },
    select(id) {
      switch (id) {
        case 1:
          this.$router.push("/industry");
          this.$emit("changIdx", 1);
          window.localStorage.setItem("activeIndex", 1);
          window.scrollTo(0, 0);
          break;
        case 2:
          this.$router.push("/city");
          this.$emit("changIdx", 2);
          window.localStorage.setItem("activeIndex", 2);
          window.scrollTo(0, 0);
          break;
        case 3:
          this.$router.push("/park");
          this.$emit("changIdx", 3);
          window.localStorage.setItem("activeIndex", 3);
          window.scrollTo(0, 0);
          break;
        default:
          break;
      }
      console.log(id);
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollHandler, true);
  },
};
</script>
<style lang="less" scoped>
.head_img {
  width: 100%;
  height: 500px;
  img {
    width: 100%;
    height: 100%;
    filter: hue-rotate(201deg);
  }
}
.showView {
  animation: fadeinShow 1.5s forwards;
}
@keyframes fadeinShow {
  0% {
    opacity: 0;
    transform: translate(100px, 0) scale(0.5);
  }
  100% {
    transform: translate(0px, 0) scale(1);
  }
}
.main {
  margin: 68px auto;
  font-size: 24px;
  text-align: center;
  .main_title {
    overflow: hidden;
    font-weight: bold;
    color: #000000;
    letter-spacing: -3px;
    text-transform: uppercase;
    font-family: Arial;
    margin-bottom: 10px;
    font-size: 36px;
  }
  .line {
    width: 25px;
    height: 3px;
    background: #0044dc;
    margin: 10px auto;
  }
}
.company_name {
  position: absolute;
  top: 173px;
  left: 78px;
  color: white;
  font-size: 60px;
  font-weight: 600;
  text-shadow: 5px 5px 5px #4a4040;
  user-select: none;
  z-index: 10;
}

.product_list {
  width: 100%;
  height: 350px;
  padding: 0 24px;
  display: flex;
  justify-content: space-around;
  .list_item {
    cursor: pointer;
    width: 334px;
    height: 100%;
    font-size: 20px;
    background: white;
    overflow: hidden;
    position: relative;
    transition: all 1.2s;
    img {
      width: 100%;
      height: 182px;
      font-size: 0px;
    }
    .info {
      color: black;
      position: absolute;
      bottom: 0;
      line-height: 24px;
      padding: 0 5px;
      text-indent: 2rem;
    }
    .topBox {
      width: 100%;
      height: 100%;
      background: white;
      position: absolute;
      left: 0;
      top: 0;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
    }
  }
  .list_item:hover .topBox {
    opacity: 0;
    transition: all 0.8s;
  }

  .list_item:hover {
    width: 450px;
    height: 400px;
    transition: all 0.5s;
    box-shadow: 10px 10px 10px #8a8888;
  }
  .list_item:hover p {
    color: #00a1e9;
    transform: translateY(-80px);
    transition: all 0.5s;
  }
  .list_item:hover img {
    transform: scale(1.1);
    height: 200px;
    transition: all 0.8s;
  }
}
.partners_list {
  width: 100%;
  max-width: 1300px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  align-items: center;
  .list_item {
    overflow: hidden;
  }
  img {
    width: 203px;
    height: 100px;
    font-size: 0px;
    border: 1px solid #f0f0f0;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.8s;
  }
  img:hover {
    transform: scale(1.1);
    transition: all 0.8s;
  }
}
</style>
